"use client"

import type React from "react"
import { useState } from "react"

interface QuoteDisplayProps {
  quote: string
  isLoading: boolean
}

export const QuoteDisplay: React.FC<QuoteDisplayProps> = ({ quote, isLoading }) => {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = async () => {
    if (!quote) return

    try {
      await navigator.clipboard.writeText(quote)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error("Failed to copy text: ", err)
    }
  }

  return (
    <div className="quote-container">
      <div className="quote-background-blur"></div>

      <div className="quote-card">
        <div className="quote-gradient-bar"></div>

        <div className="quote-content">
          {isLoading && !quote && (
            <div className="loading-state">
              <div className="loading-spinner-container">
                <div className="loading-spinner-outer"></div>
                <div className="loading-spinner-inner"></div>
              </div>
              <div className="loading-text">
                <p className="loading-primary">Crafting inspiration...</p>
                <p className="loading-secondary">AI is thinking deeply</p>
              </div>
            </div>
          )}

          {quote && (
            <div className="quote-display">
              <div className="quote-icon">❝</div>
              <div className="quote-text-container">
                <blockquote className="quote-text">{quote}</blockquote>
                <button
                  onClick={copyToClipboard}
                  className={`copy-btn ${copied ? "copied" : ""}`}
                  title="Copy to clipboard"
                >
                  {copied ? (
                    <>
                      <span className="copy-icon">✓</span>
                      <span>Copied!</span>
                    </>
                  ) : (
                    <>
                      <span className="copy-icon">📋</span>
                      <span>Copy</span>
                    </>
                  )}
                </button>
              </div>
              <div className="quote-divider"></div>
            </div>
          )}

          {!quote && !isLoading && (
            <div className="empty-state">
              <div className="empty-icon">⚡</div>
              <div className="empty-text">
                <p className="empty-primary">Ready to get inspired?</p>
                <p className="empty-secondary">Click the button below to generate a powerful motivational quote</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
